export const consumerKey = "plsozcxl4xjr4xgyc7klwnh2reufibqi";
export const consumerSecret = "ml6pp401n53wsggk528en6dcdugveu2n";
export const accessToken = "1kg5qd3e7uppdf5w7i1xx9jublbnf0eg";
export const accessTokenSecret = "8jguf49s0g833pfmbdvsg44d57h16549";
